<template>
  <div>

    <div class="modal show fade modal-success text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel120">Update Acquiring Settings</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form form-horizontal">
              <div class="row">
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-sm-3 col-form-label">
                      <label>Min Limit</label>
                    </div>
                    <div class="col-sm-9">
                      <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            v-model="min"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-sm-3 col-form-label">
                      <label>Max Limit</label>
                    </div>
                    <div class="col-sm-9">
                      <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            v-model="max"
                        />
                      </div>
                    </div>
                  </div>
                </div>
<!--                <div class="col-12 ">-->
<!--                  <div class="form-group row">-->
<!--                    <div class="col-sm-3 col-form-label">-->
<!--                      <label>Status</label>-->
<!--                    </div>-->
<!--                    <div class="col-sm-9">-->
<!--                      <select class="form-control" v-model="selectedStatus">-->
<!--                        <option :value="1">Active</option>-->
<!--                        <option :value="0">Inactive</option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <PaymentMethodSettings
                    :modelValue.sync="paymentMethodSelectedSettings"
                    ref="payemntSetting"
                    :hidePaymentMethodDropdown="true"
                />
                <div class="col-12 d-flex justify-content-end">
                  <button type="button" class="btn btn-sm btn-primary" @click="sendCall">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'settingsData', 'recordIndex'],
  data() {
    return {
      loader: false,
      index: '',
      min: '',
      max: '',
      aquiringId: '',
      code: '',
      selectedStatus: 1,
      paymentMethodSelectedSettings: {},
      paymentId: "",
      settings: {},
    }
  },
  mounted() {

  },
  methods: {
    sendCall() {

      if (this.$refs.payemntSetting.clear) {
        this.settings = null
        this.paymentMethodSelectedSettings.settings = this.settings
        let requestData = {
          type: 'update',
          minLimit: this.min*100,
          maxLimit: this.max*100,
          schemaAquiringId: this.aquiringId,
          status: this.selectedStatus,
          settings: JSON.stringify({}),
        }


        this.makeRequest('post', 'v1/update-schema-aquiring', requestData).then(callResponse => {

          this.loader = false
          if (!callResponse.error) {
            let code = callResponse.response.data.code;

            if (code == 200) {

              var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey(
                  "acquiringSchemaDetailsList"
              );
              if (acquiringSchemaDetialListStoreData) {
                acquiringSchemaDetialListStoreData.row.schema_aquirings[this.recordIndex] = callResponse.response.data.data
                this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
              }

              this.$emit('hide')
            }
          }

        });
        return
      }

      let validPaymentFileds = this.$refs.payemntSetting.validateAllFields()

      validPaymentFileds.validateAll().then(valid => {
        if (this.paymentMethodSelectedSettings.allFieldsCodes.includes(this.code)) {
          if (valid) {
            let requestData = {
              type: 'update',
              minLimit: this.min*100,
              maxLimit: this.max*100,
              schemaAquiringId: this.aquiringId,
              status: this.selectedStatus,
              settings : JSON.stringify({...this.settings}),
            }



            this.makeRequest('post', 'v1/update-schema-aquiring', requestData).then(callResponse => {

              this.loader = false
              if (!callResponse.error) {
                let code = callResponse.response.data.code;

                if (code == 200) {

                  var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey(
                      "acquiringSchemaDetailsList"
                  );
                  if (acquiringSchemaDetialListStoreData) {
                    acquiringSchemaDetialListStoreData.row.schema_aquirings[this.recordIndex] = callResponse.response.data.data
                    this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
                  }

                  this.$emit('hide')
                }
              }

            });
          }
        } else {
          let requestData = {
            type: 'update',
            minLimit: this.min*100,
            maxLimit: this.max*100,
            schemaAquiringId: this.aquiringId,
            status: this.selectedStatus,
          }


          this.makeRequest('post', 'v1/update-schema-aquiring', requestData).then(callResponse => {

            this.loader = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;

              if (code == 200) {

                var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey(
                    "acquiringSchemaDetailsList"
                );
                if (acquiringSchemaDetialListStoreData) {
                  acquiringSchemaDetialListStoreData.row.schema_aquirings[this.recordIndex] = callResponse.response.data.data
                  this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
                }

                this.$emit('hide')
              }
            }

          });
        }
      })


    },
  },
  watch: {
    settingsData(val) {
      this.min = parseFloat(val.min_limit/100).toFixed(this.amountDecimalPlaces)
      this.max = parseFloat(val.max_limit/100).toFixed(this.amountDecimalPlaces)
      this.code = val.aquiring.payment_method.code
      this.paymentId = val.aquiring.payment_method_id
      this.selectedStatus = val.status
      this.paymentMethodSelectedSettings.paymentId = this.paymentId

      this.aquiringId = val.id

      this.settings = val.settings
      this.paymentMethodSelectedSettings.settings = this.settings
      // if (val.settings) {
      //   this.settings = val.settings
      //   this.paymentMethodSelectedSettings.settings = this.settings
      // }


    },
    paymentMethodSelectedSettings(val) {
      this.paymentId = val.paymentId
      this.settings = val.settings

    }
  }
}
</script>
<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 80vh;
  overflow-y: auto;
}
</style>



